(function () {
	'use strict';

	function initMobileCtaFooterOverlap() {
		const ctaButton = document.getElementById('mobile-cta-button');
		const footer = document.getElementById('footer');
		if (!ctaButton || !footer) return;

		let ticking = false;

		function updateVisibility() {
			ticking = false;
			const buttonRect = ctaButton.getBoundingClientRect();
			const footerRect = footer.getBoundingClientRect();

			const isOverlapping =
				footerRect.top < buttonRect.bottom &&
				footerRect.bottom > buttonRect.top;

			ctaButton.classList.toggle('is-hidden-over-footer', isOverlapping);
		}

		function onScrollOrResize() {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(updateVisibility);
		}

		updateVisibility();
		window.addEventListener('scroll', onScrollOrResize, { passive: true });
		window.addEventListener('resize', onScrollOrResize);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initMobileCtaFooterOverlap);
	} else {
		initMobileCtaFooterOverlap();
	}
})();

